import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Paginator } from '../../shared/interfaces/paginator';
import { Product } from '../../shared/interfaces/product';
import { Brand } from '../../shared/interfaces/brand';
import { Category } from '../../shared/interfaces/category';
import { Subcategory } from '../../shared/interfaces/subcategory';
import { TagCount } from '../../shared/interfaces/tag';

@Injectable({
    providedIn: 'root',
})
export class ProductStepService {

    public constructor(
        private readonly http: HttpClient,
    ) {
        //
    }

    public forStep(
        workflowId: number,
        stepId: number,
        saleId: number | string,
        params: { [key: string]: number | string } = { page: 1, per_page: 24 },
    ): Observable<{ product_type?: string | null, data: {
            products: Paginator<Product> | Product[],
            categories: Category[],
            subcategories?: Subcategory[],
            brands?: Brand[],
            tags: TagCount[],
        } }> {
        return this.http.get<{ product_type?: string | null, data: {
                products: Paginator<Product> | Product[],
                categories: Category[],
                subcategories?: Subcategory[],
                brands?: Brand[],
                tags: TagCount[],
            } }>(
                `/api/sales/workflows/${workflowId}/steps/${stepId}/sale/${saleId}/products`,
                { params },
            );
    }
}
